import { ApplicationEventType } from '~shared/modules/application-event/constants';

export namespace GATrackingApplicationEventMapperFunctionGenerator {

  export function generateMapFunctionName(type: ApplicationEventType): string {
    const key = Object.keys(ApplicationEventType).find(k => ApplicationEventType[k] === type);
    return `map${key}Event`;
  }
}
